import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {WeaponPrefabs} from './weapon-prefabs.js';
import {gameState} from '../state/GameState.js';
import {Weapon} from '../state/combat/Weapon.js';
import {WeaponComponent} from './weapon-component.js';

export class WeaponSlot extends Component {
    static TypeName = 'weapon-slot';

    @property.object({required: true})
    handToHoldWeapon!: Object3D;
    private _currentWeapon: Object3D | null = null;

    get hasWeapon() {
        return this._currentWeapon !== null;
    }

    attachWeapon(weapon: Object3D) {
        this.removeWeapon();
        this._currentWeapon = weapon.clone();
        this._currentWeapon.resetPosition();
        this._currentWeapon.parent = this.handToHoldWeapon;
    }

    removeWeapon() {
        if (this._currentWeapon) {
            this._currentWeapon.destroy();
        }
    }

    get currentWeapon(): Object3D | null {
        return this._currentWeapon;
    }

    start(): void {
        gameState.currentPlayer.propertyChanged.add((prop) => {
            if (prop === 'weapon') {
                this.handleWeaponChange();
            }
        });

        // initialy check if player has a weapon and attach it
        this.handleWeaponChange();
    }

    private handleWeaponChange() {
        if (gameState.currentPlayer.weapon) {
            // in case the weapon prefabs are not loaded yet, wait for them
            if (!WeaponPrefabs.instance.weaponPrefabs) {
                const tempHandler = () => {
                    this.handleWeaponChange();
                    WeaponPrefabs.instance.onPrefabsLoaded.remove(tempHandler);
                };
                WeaponPrefabs.instance.onPrefabsLoaded.add(tempHandler);
                return;
            }

            // find weapon in weaponPrefabs
            const weapon = WeaponPrefabs.instance.weaponPrefabs.children.find(
                (w) => w.name == gameState.currentPlayer.weapon?.internalName
            );

            if (weapon) {
                this.attachWeapon(weapon);
            }
        } else {
            this.removeWeapon();
        }
    }
}
